import { Box } from "@mui/material";
import React from "react";
import AutorenewIcon from '@mui/icons-material/Autorenew';

const LoadingIcon = () => {
  return (
    <Box
      component={AutorenewIcon}
      sx={{
        width: "30px",
        fontSize: "20px",
        mr: "10px",
        alignSelf: "flex-start",
        color: "#00467d",
        transform: "horizontal-flip",
        animation: "spin 4s linear infinite",
        "@keyframes spin": { "100%": { transform: "rotate(360deg)" } },
      }}
    />
  );
};
export default LoadingIcon;
